export const RouteConstant = {
    PBE_CONFIGURE_HOME: 'pbeConfigureHome',
    PBE_TERMS_AND_CONDITIONS: 'pbetermcondition',
    PBE_TERMINATE: 'pbeTerminate',
    PBE_IDENTIFICATION: 'pbeIdentification',
    PBE_ODOMETER: 'pbeOdometer',
    PBE_LICENSE_PLATE: 'pbeLicencePlate',
    PBE_GPC_MESSAGE: 'pbeGpcMessage',
    PBE_WIDE_SHOT: 'pbeWideshot',
    PBE_CLOSEUP_SHOT: 'pbeCloseUpShot',
    PBE_FOUR_CORNERS: 'pbeFourCorners',
    PBE_REQUEST_ADDITIONAL: 'pbeRequestAdditional',
    PBE_REQUEST_OPTIONAL: 'pbeRequestOptional',
    PBE_WALK_AROUND_VIDEO: 'pbeWalkAroundVideo',
    PBE_YES_NO: 'pbeYesNo',
    PBE_SINGLE_CHOICE_SELECTION: 'pbeSingleChoiceSelect',
    PBE_MULTI_CHOICE_SELECTION: 'pbeMultiChoiceSelect',
    PBE_VIN_DECODE: 'pbeVinDecode',
    PBE_WIDE_ENHANCED: 'pbeWideEnhanced',
    PBE_CLOSEUP_ENHANCED: 'pbeCloseupEnhanced',
    PBE_SELECT_SHOP: 'pbeSelectShop',
    PBE_DOWNLOAD_ARTIFACTS: 'download-artifacts',
    PBE_VIN_STICKER: 'pbeVinSticker',
    PBE_ESTIMATOR_SUMMARY: 'pbeEstimatorSummary'
};
//# sourceMappingURL=RouteConstant.js.map